module.exports = __webpack_public_path__ + "static/media/img_Inscription_name1@3x.75ea1f4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Inscription_name1@3x.png
// module id = 991
// module chunks = 0